// HlsPlayer 컴포넌트 수정
import React, { useEffect, useRef } from 'react';
import Hls from 'hls.js';

const HlsPlayer = ({ src }) => {  // src로 prop 이름 변경
  const videoRef = useRef(null);

  useEffect(() => {
    let hls;
    
    if (videoRef.current && src) {
      console.log('HLS 초기화 시작:', src);
      
      if (Hls.isSupported()) {
        hls = new Hls({
        });
        
        hls.on(Hls.Events.MEDIA_ATTACHED, () => {
        });
        
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          videoRef.current.play().catch(err => console.error('자동 재생 실패:', err));
        });
        
        hls.on(Hls.Events.ERROR, (event, data) => {
        });
        
        hls.loadSource(src);
        hls.attachMedia(videoRef.current);
      } else if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
        videoRef.current.src = src;
        videoRef.current.addEventListener('loadedmetadata', () => {
          videoRef.current.play().catch(err => console.error('자동 재생 실패:', err));
        });
      }
    }

    return () => {
      if (hls) {
        hls.destroy();
      }
    };
  }, [src]);

  return (
    <video
      ref={videoRef}
      controls
      autoPlay
      muted
      style={{ width: '100%', height: '100%', objectFit: 'contain', background:'black', }}
    />
  );
};

export default HlsPlayer;